import { inject, Injectable } from '@angular/core';
import { BaseResponseDto, GetVolunteerFilter, Volunteer } from '@aoe/client';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api.service';
import { SessionStorageService } from '../session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class VolunteersService extends ApiService {

  private readonly sessionService = inject(SessionStorageService);


  getVolunteer(filters: GetVolunteerFilter): Observable<BaseResponseDto<Volunteer.VolunteerListDto>> {
    return this.http.get<BaseResponseDto<Volunteer.VolunteerListDto>>(`${environment.apiVolunteers}/volunteer`, { headers: { 'Authorization': `Bearer ${this.sessionService.token}` }, params: { ...filters } });
  }



}
